module.exports = __webpack_public_path__ + "static/media/photo2.2f3221fa.png";